import { ExcelForecastUploadRequest } from '@futrli-sdk/predict';

export const PREVIOUS_ACTUALS_FINANCIAL_YEARS = 2;

export type ForecastWindowSpec =
  | {
      kind: 'custom-years';
      duration_years: number;
    }
  | {
      kind: 'full-financial-years-with-actuals';
      actuals_financial_years: typeof PREVIOUS_ACTUALS_FINANCIAL_YEARS;
      forecast_financial_years: number;
    }
  | {
      kind: 'full-financial-years-without-actuals';
      forecast_financial_years: number;
    };

export interface ForecastWindowPayload {
  window_from?: string | null;
  window_spec?: ForecastWindowSpec;
}

export type ExcelForecastCreatePayload = Omit<ExcelForecastUploadRequest, 'window_from' | 'window_spec'> &
  ForecastWindowPayload;
